<a *ngIf="canCreate() && light" data-target="#createcustomermodal" data-toggle="modal" 
class="btn-icon opacity" style="position: absolute; top:10px; right:10px;">
    <span class="material-icons icon-color bg-lightgrey rounded-circle text-muted f-24 w-35 h-35 lh-35 align-middle text-center">
        add
    </span>
</a>
<div class="modal fade" id="createcustomermodal" tabindex="-1" role="dialog" aria-labelledby="customerusercreation" >
<div class="modal-dialog modal-customer modal-dialog-centered" role="document">
    <div class="modal-content">
        <app-loadconfirm *ngIf="showSpinner" [text]="'orguseradd.loadconfirmcreate'| trans " [icon]="'pending'"></app-loadconfirm>
        <!-----<div [@inbgOutAnimation] *ngIf="showSpinner" class="loading_overlay rounded">
            <div class="loader-bg">
              <div class="loader"></div>
          </div>
          </div>--->
      <div class="modal-header">
        <h5 class="modal-title">{{ 'customerusercreate.title' | trans }}</h5>
        <span #closemodal data-dismiss="modal" aria-label="Close" class="material-icons cursor-pointer">
            close
            </span>
      </div>
      <div class="modal-body">
        <div class="row">
            <div class="col">   
                <form (change)="validate()" class="form-signin" action="#" role="form">
                    <div *ngIf="errorMessage!=null" class="alert alert-danger">
                        <h6 class="error-msg">{{ errorMessage | trans }}</h6>
                    </div>
                    <div class="form-group">
                        <label class="f-13 mb-0 font-weight-light" for="signupName{{createCustomerUser.userId}}">{{ 'customerusercreate.name' | trans }}</label>
                        <input (keyup)="validate()" id="signupName{{createCustomerUser.userId}}"  type="text" maxlength="50" 
                        class="form-control" name="fullname" [(ngModel)]="createCustomerUser.fullname" required>
                    </div>
                    <div class="form-group">
                        <label class="f-13 mb-0 font-weight-light" for="signupJobTitle{{createCustomerUser.userId}}">{{ 'customerusercreate.jobtitle' | trans }}</label>
                        <input (keyup)="validate()" id="signupJobTitle{{createCustomerUser.userId}}"  type="text" maxlength="50" 
                        class="form-control" name="jobtitle" [(ngModel)]="createCustomerUser.jobtitle" required>
                    </div>
                    <div class="form-group">
                        <label class="f-13 mb-0 font-weight-light" for="signupEmail{{createCustomerUser.userId}}">{{ 'customerusercreate.email' | trans }}</label>
                        <input (ngModelChange)="onEmailChange($event)" [ngClass]="{'customvalidator-invalid': userfieldValidator == false, 'customvalidator-valid': userfieldValidator == true }" (keyup)="validate()" id="signupEmail{{createCustomerUser.userId}}" type="email"  maxlength="50" 
                        class="form-control" name="email" [(ngModel)]="createCustomerUser.email" required>
                    </div>
                    <div class="form-group ">
                        <label class="f-13 mb-0 font-weight-light" for="signupUsername{{createCustomerUser.userId}}">{{ 'customerusercreate.username' | trans }}</label>
                        <input (ngModelChange)="onUsernameChange($event)" [ngClass]="{'customvalidator-invalid': userfieldValidator == false, 'customvalidator-valid': userfieldValidator == true }" (keyup)="validate()" id="signupUsername{{createCustomerUser.userId}}"  type="text"  maxlength="50" 
                        class="form-control" name="username" [(ngModel)]="createCustomerUser.username" required>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group cursor-pointer" (click)="sendinvitetogge()">
                                <div class="form-check form-check-inline">
                                    <input (change)="validate()" class="form-check-input" type="checkbox" id="sendinvite{{createCustomerUser.userId}}" name="sendinvite" [(ngModel)]="createCustomerUser.sendinvite"  >
                                    <label class="f-13 mb-0 font-weight-light" for="sendinvite{{createCustomerUser.userId}}">{{ 'customerusercreate.sendinvitationemail' | trans }}</label>
                                </div>
                                <div *ngIf="!createCustomerUser.sendinvite" class="alert alert-secondary" role="alert">
                                    <p class="mb-0">{{ 'customeruseredit.sendalert' | trans }}</p>
                                  </div>
                                <div *ngIf="createCustomerUser.sendinvite" class="alert alert-success" role="alert">
                                    <p class="mb-0">{{ 'customeruseredit.sendalert2' | trans }}</p>
                                  </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group cursor-pointer" (click)="activeusertoggle()">
                                <div class="form-check form-check-inline">
                                    <input (change)="validate()" class="form-check-input" type="checkbox" id="activate{{createCustomerUser.userId}}" name="activate" [(ngModel)]="createCustomerUser.isactive"  >
                                    <label class="control-label" for="activate{{createCustomerUser.userId}}">{{ 'customeruseredit.activated' | trans }}</label>
                                </div>
                                <div *ngIf="!createCustomerUser.isactive" class="alert alert-secondary" role="alert">
                                    <p class="mb-0">{{ 'customeruseredit.activatedalert' | trans }}</p>
                                  </div>
                                <div *ngIf="createCustomerUser.isactive" class="alert alert-success" role="alert">
                                    <p class="mb-0">{{ 'customeruseredit.activatedalert2' | trans }}</p>
                                  </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!---<div class="col">
                            <button data-dismiss="modal" class="btn-close w-100 mt-2 cursor-pointer">
                                <h6 class="btn-save-text">{{ 'customerusercreate.close' | trans }}</h6></button>
                        </div>-->
                        <div class="col">
                            <button [ngClass]="{'btn-disabled': !formIsValid}" [disabled]="!formIsValid" (click)="onCreate()" id="signupSubmit" 
                            type="submit" class="btn-save cursor-pointer w-100 mt-2">
                                <h6 class="btn-save-text">{{ 'customerusercreate.createcustomeruser' | trans }}</h6>
                              </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
</div>

